const CommandStatusComponent = {
	template: require('./status.html'),
	restrict: 'E',
	bindings: {
		healthStatus: '<'
	},
	controller: ['CommandService', CommandStatusController],
	controllerAs: 'vm'
};

function CommandStatusController(CommandService) {
	var vm = this;

	vm.healthStatusTypes = {};
	vm.selectedState = null;

	vm.showState = showState;

	vm.$onInit = function() {
		vm.healthStatusTypes = CommandService.healthStatusTypes;
		showFirstError(vm.healthStatus);
	};

	vm.$onChanges = function() {
		if (vm.healthStatus) {
			showFirstError(vm.healthStatus);
		}
	};

	function showFirstError(alertStatuses) {
		var firstError = _.chain(alertStatuses)
			.filter(function(health) {
				return health.status === vm.healthStatusTypes.error;
			})
			.first()
			.value();
		if (firstError) {
			showState(firstError.name);
		}
	}

	function showState(selected) {
		vm.selectedState = vm.selectedState === selected ? null : selected;
	}
}

export default CommandStatusComponent;
